
import { FileUploaded_$reflection, FileUploadResponse } from "../Shared/File.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ensureRequestBodySize } from "../ErrorHandling.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

function toFileUploadResponse(response) {
    if (response.tag === 1) {
        return new FileUploadResponse(0, []);
    }
    else {
        return new FileUploadResponse(1, [response.fields[0]]);
    }
}

function postImageFile(url, formData) {
    let pr_1;
    const formData_1 = formData;
    pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        ensureRequestBodySize(formData_1);
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_1])]), undefined, (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), FileUploaded_$reflection()));
        }, refreshOn)))(true);
    }));
    return pr_1.then(toFileUploadResponse);
}

export function Cmd_uploadImage(successMsg, errorMsg, formData) {
    return Cmd_OfPromise_either((formData_1) => postImageFile("/api/files/images", formData_1), formData, successMsg, errorMsg);
}

export function Cmd_uploadSignature(formData, successMsg, errorMsg) {
    return Cmd_OfPromise_either((formData_1) => postImageFile("/api/files/signatures", formData_1), formData, successMsg, errorMsg);
}

